const INJ = ({ ...props }) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.97631 9.79586C8.17994 9.53369 8.39577 9.2825 8.6116 9.03009C8.62135 9.0179 8.6433 9.01546 8.65306 9.00327C8.67257 8.97888 8.70427 8.96303 8.72378 8.93864L8.74329 8.91425C8.89327 8.77159 9.05301 8.61673 9.23836 8.48138C9.85411 7.99213 10.5446 7.60511 11.2832 7.33517C13.5757 6.51331 16.1266 7.02057 18.1276 8.95205C20.9199 11.6286 20.67 15.9427 18.4409 18.8094C15.6218 23.0821 10.7796 29.0448 17.485 34.3857C18.6909 35.3465 19.5847 36.1379 23.3818 37.2597C20.8992 37.728 18.5958 37.5829 16.0327 36.9134C14.2195 35.866 11.3686 33.626 10.3992 30.5995C8.93229 26.011 12.9794 19.1509 14.9353 16.5097C17.6203 12.8516 13.2757 8.89474 10.0773 13.3137C8.40431 15.6159 5.48026 22.1334 6.49599 26.967C7.08983 29.7082 7.88242 31.7067 11.0235 34.4515C10.4309 34.0928 9.86417 33.6931 9.32737 33.2553C2.02822 26.3049 2.87568 15.5574 7.97631 9.79586V9.79586Z"
      fill="url(#paint0_linear_541_358)"
    />
    <path
      d="M32.8208 31.7371C32.6172 31.9993 32.4013 32.2505 32.1855 32.5029C32.1758 32.5151 32.1538 32.5175 32.1441 32.5297C32.1245 32.5541 32.0928 32.57 32.0733 32.5944L32.0538 32.6188C31.9038 32.7614 31.7441 32.9163 31.5588 33.0516C30.943 33.5409 30.2526 33.9279 29.5139 34.1978C27.2215 35.0197 24.6705 34.5124 22.6695 32.581C19.8772 29.9044 20.1272 25.5903 22.3562 22.7236C25.1741 18.4509 30.0175 12.4882 23.3122 7.14732C22.1062 6.18646 21.2124 5.39509 17.4141 4.27327C19.8979 3.80503 22.2013 3.95013 24.7644 4.61957C26.5776 5.66701 29.4285 7.90699 30.3979 10.9335C31.8648 15.522 27.8177 22.3821 25.8619 25.0233C23.1768 28.6814 27.5214 32.6383 30.7198 28.2193C32.3928 25.9171 35.3169 19.3996 34.3011 14.566C33.7061 11.8248 32.9147 9.82628 29.7736 7.08148C30.3552 7.43265 30.921 7.83139 31.4697 8.27768C38.7677 15.2281 37.9214 25.9756 32.8208 31.7371V31.7371Z"
      fill="url(#paint1_linear_541_358)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_541_358"
        x1="3.99994"
        y1="20.7665"
        x2="36.7974"
        y2="20.7665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0082FA" />
        <stop offset="1" stop-color="#00F2FE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_541_358"
        x1="3.99977"
        y1="20.7665"
        x2="36.7972"
        y2="20.7665"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0082FA" />
        <stop offset="1" stop-color="#00F2FE" />
      </linearGradient>
    </defs>
  </svg>
);
export default INJ;
